// extracted by mini-css-extract-plugin
export default {"participant-linked":"ParticipantName_participant-linked__-W-os"};